// extracted by mini-css-extract-plugin
export default {"contents":"gI-z","sectionHeading":"hI-z"};